import { defineComponent as x, reactive as Ve, watch as Ze, computed as g, openBlock as c, createElementBlock as u, normalizeClass as b, Fragment as M, renderList as E, createElementVNode as _, renderSlot as w, withDirectives as Fe, vShow as De, nextTick as Ke, pushScopeId as ve, popScopeId as be, createTextVNode as k, toDisplayString as S, createCommentVNode as A, createVNode as Y, Transition as Re, withCtx as T, withKeys as G, getCurrentInstance as ge, createBlock as V, createSlots as We, resolveDynamicComponent as X, getCurrentScope as Ge, onScopeDispose as qe, unref as Ue, ref as me, watchEffect as Ye, onMounted as Qe, normalizeStyle as oe, normalizeProps as Z, guardReactiveProps as F, useModel as Je } from "vue";
const Xe = (e) => (ve("data-v-8bf7a627"), e = e(), be(), e), et = ["id"], tt = ["id"], nt = ["aria-controls", "aria-expanded", "onClick"], ot = /* @__PURE__ */ Xe(() => /* @__PURE__ */ _("path", {
  d: "M7.38 9.73L.26 2.4a.92.92 0 010-1.28l.83-.85a.86.86 0 011.24 0L8 6.06l5.67-5.8a.86.86 0 011.24 0l.83.85c.35.35.35.93 0 1.28L8.62 9.73a.86.86 0 01-1.24 0z",
  fill: "currentColor",
  "fill-rule": "nonzero"
}, null, -1)), st = [
  ot
], lt = ["id", "aria-labelledby"], j = "abc-accordion", rt = /* @__PURE__ */ x({
  __name: "AbcAccordion",
  props: {
    id: {},
    items: {},
    headerClass: {},
    panelClass: {}
  },
  setup(e) {
    const t = e, n = Ve([]), s = (h) => h.map((y) => {
      var $;
      const m = (($ = n.find((ne) => ne.id === y.id)) == null ? void 0 : $.isExpanded) ?? !1;
      return {
        ...y,
        isExpanded: m
      };
    });
    Ze(
      () => t.items,
      (h) => {
        n.splice(0, n.length, ...s(h));
      },
      { immediate: !0 }
    );
    const r = g(() => {
      const h = [`${j}__header`];
      return t.headerClass && h.push(t.headerClass), h;
    }), o = g(() => {
      const h = [`${j}__panel`];
      return t.panelClass && h.push(t.panelClass), h;
    }), l = (h) => `${t.id}-accordion-item-${h}`, i = (h) => `${t.id}-accordion-trigger-${h}`, d = (h) => `${t.id}-accordion-panel-${h}`, f = (h) => {
      var m, $;
      const y = n.indexOf(h);
      y !== -1 && (($ = (m = document.getElementById(l(y))) == null ? void 0 : m.scrollIntoView) == null || $.call(m, {
        block: "nearest",
        behavior: "smooth"
      }));
    }, a = async (h) => {
      h.isExpanded = !0, await Ke(), f(h);
    }, p = (h) => {
      h.isExpanded = !1;
    }, v = (h) => {
      h.isExpanded ? p(h) : a(h);
    };
    return (h, y) => (c(), u("div", {
      class: b(j)
    }, [
      (c(!0), u(M, null, E(n, (m, $) => (c(), u("div", {
        id: l($),
        key: $,
        class: b(`${j}__item`)
      }, [
        _("h3", {
          id: i($),
          class: b(r.value)
        }, [
          _("button", {
            "aria-controls": d($),
            "aria-expanded": m.isExpanded,
            class: b([`${j}__header-item`]),
            type: "button",
            onClick: (ne) => v(m)
          }, [
            w(h.$slots, "buttonContent", {
              data: m.data,
              className: `${j}__btn-content`
            }),
            (c(), u("svg", {
              class: b({
                [`${j}__btn-icon`]: !0,
                [`${j}__btn-icon--expanded`]: m.isExpanded
              }),
              role: "presentation",
              width: "16",
              height: "10",
              viewBox: "0 0 16 10",
              xmlns: "http://www.w3.org/2000/svg"
            }, st, 2))
          ], 10, nt)
        ], 10, tt),
        Fe(_("section", {
          id: d($),
          "aria-labelledby": i($),
          class: b(o.value),
          role: "region"
        }, [
          w(h.$slots, "panel", {
            data: m.data
          })
        ], 10, lt), [
          [De, m.isExpanded]
        ])
      ], 10, et))), 128))
    ]));
  }
}), O = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [s, r] of t)
    n[s] = r;
  return n;
}, at = /* @__PURE__ */ O(rt, [["__scopeId", "data-v-8bf7a627"]]), se = "abc-badge", it = /* @__PURE__ */ x({
  __name: "AbcBadge",
  props: {
    color: { default: "primary" }
  },
  setup(e) {
    const t = e, n = g(() => [se, `${se}--${t.color}`]);
    return (s, r) => (c(), u("span", {
      class: b(n.value)
    }, [
      w(s.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), ct = /* @__PURE__ */ O(it, [["__scopeId", "data-v-c99d2028"]]);
var ut = 13, dt = 27, le = 32, ht = 37, re = 38, _t = 39, ae = 40;
const ft = ["id"], pt = { class: "v-select__inner" }, vt = ["id", "disabled", "aria-expanded", "aria-labelledby"], bt = {
  key: 0,
  class: "v-select__prepend"
}, gt = {
  key: 1,
  class: "v-select__placeholder"
}, mt = { class: "v-select__selected" }, wt = { class: "v-select__arrow" }, yt = /* @__PURE__ */ _("svg", { viewBox: "0 0 255 255" }, [
  /* @__PURE__ */ _("path", { d: "M0 64l128 127L255 64z" })
], -1), $t = {
  key: 0,
  class: "v-select__menu"
}, St = ["aria-activedescendant", "aria-labelledby"], Ot = ["id", "onMousedown", "aria-selected"], Ct = {
  key: 1,
  class: "v-select__no-options"
}, Tt = /* @__PURE__ */ _("span", null, "No options provided", -1);
function kt(e, t, n, s, r, o) {
  return c(), u("div", {
    class: b(["v-select", o.className])
  }, [
    o.hasSlot("label") || n.label ? (c(), u("span", {
      key: 0,
      class: "v-select__label",
      id: o.labelId
    }, [
      w(e.$slots, "label", {}, () => [
        k(S(n.label) + ":", 1)
      ])
    ], 8, ft)) : A("", !0),
    _("div", pt, [
      _("button", {
        class: "v-select__btn",
        id: o.buttonId,
        ref: "button",
        disabled: n.disabled,
        "aria-expanded": o.ariaExpanded,
        "aria-labelledby": `${o.labelId ? o.labelId : ""} ${o.buttonId}`,
        type: "button",
        "aria-haspopup": "listbox",
        onMousedown: t[0] || (t[0] = (...l) => o.toggle && o.toggle(...l)),
        onKeydown: t[1] || (t[1] = (...l) => o.keydownHandler && o.keydownHandler(...l)),
        onBlur: t[2] || (t[2] = (...l) => o.buttonBlurHandler && o.buttonBlurHandler(...l))
      }, [
        o.hasSlot("prepend") ? (c(), u("span", bt, [
          w(e.$slots, "prepend")
        ])) : A("", !0),
        (n.placeholder || o.hasSlot("placeholder")) && n.value === void 0 || !o.optionsHasValue ? (c(), u("span", gt, [
          w(e.$slots, "placeholder", { placeholder: n.placeholder }, () => [
            k(S(n.placeholder), 1)
          ])
        ])) : A("", !0),
        _("span", mt, [
          n.value !== void 0 && o.optionsHasValue ? w(e.$slots, "selected", {
            key: 0,
            value: n.value,
            option: o.currentOption
          }, () => [
            k(S(o.currentOption ? o.currentOption.label : n.value), 1)
          ]) : A("", !0)
        ]),
        _("span", wt, [
          w(e.$slots, "arrow", {}, () => [
            yt
          ])
        ])
      ], 40, vt),
      Y(Re, {
        name: n.transition ? n.transition.name : "",
        mode: n.transition ? n.transition.mode : ""
      }, {
        default: T(() => [
          r.open ? (c(), u("div", $t, [
            n.options && n.options.length ? (c(), u("ul", {
              key: 0,
              class: "v-select__list",
              ref: "list",
              "aria-activedescendant": n.value && o.getOptionId(n.value),
              "aria-labelledby": o.labelId,
              role: "listbox",
              tabindex: "-1",
              onKeydown: t[3] || (t[3] = (...l) => o.keydownHandler && o.keydownHandler(...l)),
              onKeyup: [
                t[4] || (t[4] = G((...l) => o.setLastSelected && o.setLastSelected(...l), ["end"])),
                t[5] || (t[5] = G((...l) => o.setFirstSelected && o.setFirstSelected(...l), ["home"])),
                t[6] || (t[6] = G((...l) => o.escapeHandler && o.escapeHandler(...l), ["esc"]))
              ],
              onBlur: t[7] || (t[7] = (...l) => o.menuBlurHandler && o.menuBlurHandler(...l))
            }, [
              (c(!0), u(M, null, E(n.options, (l, i) => (c(), u("li", {
                class: b(["v-select__option", { "v-select__option--selected": o.isSelected(l) }]),
                key: i,
                id: o.getOptionId(l),
                role: "option",
                ref_for: !0,
                ref: "options",
                onMousedown: (d) => o.clickHandler(l),
                "aria-selected": o.isSelected(l) ? "true" : "false"
              }, [
                w(e.$slots, "option", {
                  option: l,
                  value: n.value
                }, () => [
                  _("span", null, S(l.label), 1)
                ])
              ], 42, Ot))), 128))
            ], 40, St)) : (c(), u("div", Ct, [
              w(e.$slots, "no-optioms", {}, () => [
                Tt
              ])
            ]))
          ])) : A("", !0)
        ]),
        _: 3
      }, 8, ["name", "mode"])
    ])
  ], 2);
}
const xt = {
  name: "VueAccessibleSelect",
  props: {
    options: {
      type: Array,
      required: !0
    },
    value: {
      required: !0
    },
    transition: {
      type: Object,
      default: () => ({})
    },
    label: String,
    placeholder: String,
    disabled: Boolean
  },
  emits: ["change", "open", "close", "input"],
  data() {
    const e = ge();
    return {
      open: !1,
      timeout: null,
      printedText: "",
      localId_: e.uid,
      _vm: e
    };
  },
  computed: {
    labelId() {
      return this.label ? `v-select-label-${this.localId_}` : !1;
    },
    buttonId() {
      return `v-select-button-${this.localId_}`;
    },
    ariaExpanded() {
      return this.open ? "true" : "false";
    },
    className() {
      return {
        "v-select--opened": this.open,
        "v-select--disabled": this.disabled
      };
    },
    currentOption() {
      return Array.isArray(this.options) && this.options.find((e) => e.value === this.value);
    },
    currentOptionIndex() {
      return this.options.findIndex((e) => e === this.currentOption);
    },
    optionsHasValue() {
      return this.options.findIndex((e) => e.value === this.value) !== -1;
    }
  },
  watch: {
    open(e) {
      e ? setTimeout(() => {
        document.addEventListener("mousedown", this.clickListener);
        const { list: t } = this.$refs;
        if (t) {
          t.focus();
          const { value: n } = this;
          (n || n === 0) && this.scrollToSelected();
        }
        this.$emit("open");
      }, 0) : (document.removeEventListener("mousedown", this.clickListener), this.$emit("close"));
    },
    value(e) {
      (e || e == 0) && this.scrollToSelected();
    }
  },
  /*
   * SSR Safe Client Side ID attribute generation
   * id's can only be generated client side, after mount.
   * this.uid is not synched between server and client.
   */
  mounted() {
    this.$nextTick(() => {
      this.localId_ = this._vm.uid;
    });
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    emit(e) {
      this.$emit("input", e), this.$emit("change", e);
    },
    clickListener(e) {
      const { target: t } = e, n = t.closest(".v-select__btn");
      t.closest(".v-select__list") === this.$refs.list || n === this.$refs.button || (this.open = !1);
    },
    isSelected(e) {
      return this.value === e.value;
    },
    clickHandler(e) {
      this.emit(e.value), this.open = !1;
    },
    async keydownHandler(e) {
      if (e.keyCode === dt)
        return;
      [le, ht, re, _t, ae].indexOf(e.keyCode) > -1 && e.preventDefault();
      const { currentOptionIndex: t } = this;
      switch (e.keyCode) {
        case le:
          this.open = !0;
          break;
        case re:
          t !== 0 && this.emit(this.options[t - 1].value);
          return;
        case ae:
          t !== this.options.length - 1 && this.emit(this.options[t + 1].value);
          return;
        case ut:
          this.toggle(), await this.$nextTick(), this.open || this.$refs.button.focus();
      }
      this.printHandler(e);
    },
    getOptionId(e) {
      return `v-select-option-${this.options.indexOf(e)}_${this.localId_}`;
    },
    setFirstSelected() {
      this.emit(this.options[0].value);
    },
    setLastSelected() {
      this.emit(this.options[this.options.length - 1].value);
    },
    escapeHandler() {
      this.open = !1, this.$refs.button.focus();
    },
    printHandler(e) {
      const t = e.key ? e.key : String.fromCharCode(e.keyCode);
      t.length > 1 || (this.printedText += t.toUpperCase(), this.selectByText(this.printedText), clearTimeout(this.timeout), this.timeout = null, this.timeout = setTimeout(() => {
        this.printedText = "";
      }, 500));
    },
    selectByText(e) {
      for (let t of this.shiftOptions(this.currentOptionIndex))
        if (String(t.label).toUpperCase().startsWith(e)) {
          if (!this.currentOption) {
            this.emit(t.value);
            return;
          }
          if (this.currentOption.value !== t.value) {
            this.emit(t.value);
            return;
          }
        }
    },
    scrollToSelected() {
      if (Array.isArray(this.$refs.options)) {
        const e = this.$refs.options[this.currentOptionIndex];
        if (e) {
          const { offsetTop: t, clientHeight: n } = e, { list: s } = this.$refs, r = s.scrollTop + s.clientHeight;
          t < s.scrollTop ? s.scrollTop = t : t + n > r && (s.scrollTop = t - s.clientHeight + n);
        }
      }
    },
    buttonBlurHandler(e) {
      let t = e.relatedTarget;
      t === null && (t = document.activeElement), t !== this.$refs.list && this.open && (this.open = !1);
    },
    menuBlurHandler(e) {
      let t = e.relatedTarget;
      t === null && (t = document.activeElement), t !== this.$refs.button && (this.open = !1);
    },
    hasSlot(e) {
      return !!this.$slots[e];
    },
    shiftOptions(e) {
      const { options: t } = this;
      if (e === -1 || this.timeout)
        return t;
      const n = t.slice(0, e - 1);
      return [...t.slice(
        e + 1,
        t.length
      ), ...n];
    }
  }
}, jt = /* @__PURE__ */ O(xt, [["render", kt]]), Mt = (e) => (ve("data-v-b565624f"), e = e(), be(), e), At = { class: "sr-only" }, Et = /* @__PURE__ */ Mt(() => /* @__PURE__ */ _("path", {
  d: "M.293.293A1 1 0 011.613.21l.094.083L7 5.585 12.293.293a1 1 0 011.32-.083l.094.083a1 1 0 01.083 1.32l-.083.094-6 6a1 1 0 01-1.32.083l-.094-.083-6-6a1 1 0 010-1.414z",
  fill: "currentColor",
  "fill-rule": "nonzero"
}, null, -1)), It = [
  Et
], L = "abc-dropdown", Lt = /* @__PURE__ */ x({
  __name: "AbcDropdown",
  props: {
    modelValue: {},
    options: {},
    color: {},
    disabled: { type: Boolean },
    fullWidth: { type: Boolean },
    placeholder: {},
    ariaLabel: {}
  },
  emits: ["update:modelValue", "close"],
  setup(e, { emit: t }) {
    const n = e, s = t, r = g(() => ({
      [L]: !0,
      [`${L}--disabled`]: n.disabled,
      [`${L}--full-width`]: n.fullWidth,
      [`${L}--primary`]: n.color === "primary"
    }));
    function o(i) {
      s("update:modelValue", i);
    }
    function l() {
      s("close");
    }
    return (i, d) => (c(), V(jt, {
      class: b(r.value),
      disabled: i.disabled,
      label: i.ariaLabel,
      options: i.options,
      placeholder: i.placeholder,
      value: n.modelValue,
      onChange: d[0] || (d[0] = (f) => o(f)),
      onClose: d[1] || (d[1] = (f) => l())
    }, We({
      arrow: T(() => [
        _("span", {
          class: b(`${L}__arrow-separator`)
        }, null, 2),
        _("span", null, [
          (c(), u("svg", {
            width: "14",
            height: "8",
            xmlns: "http://www.w3.org/2000/svg",
            class: b(`${L}__arrow-icon`),
            role: "presentation"
          }, It, 2))
        ])
      ]),
      selected: T(({ option: f }) => [
        k(S(f.label), 1)
      ]),
      option: T(({ option: f }) => [
        k(S(f.label), 1)
      ]),
      _: 2
    }, [
      i.ariaLabel ? {
        name: "label",
        fn: T(() => [
          _("span", At, S(i.ariaLabel), 1)
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["class", "disabled", "label", "options", "placeholder", "value"]));
  }
}), Ht = /* @__PURE__ */ O(Lt, [["__scopeId", "data-v-b565624f"]]), ie = "abc-floating-container", Pt = /* @__PURE__ */ x({
  __name: "AbcFloatingContainer",
  props: {
    withHeader: { type: Boolean }
  },
  setup(e) {
    const t = e, n = g(() => ({
      [ie]: !0,
      [`${ie}--no-header`]: !t.withHeader
    }));
    return (s, r) => (c(), u("div", {
      class: b(n.value)
    }, [
      w(s.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), Bt = /* @__PURE__ */ O(Pt, [["__scopeId", "data-v-1d844d60"]]), q = "abc-heading", Nt = /* @__PURE__ */ x({
  __name: "AbcHeading",
  props: {
    color: { default: "secondary" },
    size: { default: "md" },
    tag: { default: "h1" }
  },
  setup(e) {
    const t = e, n = g(() => [
      q,
      `${q}--${t.size}`,
      `${q}--${t.color}`
    ]);
    return (s, r) => (c(), V(X(s.tag), {
      class: b(n.value)
    }, {
      default: T(() => [
        w(s.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), zt = /* @__PURE__ */ O(Nt, [["__scopeId", "data-v-8f97973c"]]), Vt = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Zt = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "M15.792 5.343a1.083 1.083 0 0 1 1.654 1.396l-.071.084-8.106 8.667c-.403.43-1.07.456-1.504.076l-.078-.076-4.895-5.234A1.083 1.083 0 0 1 4.295 8.7l.08.077 4.103 4.388 7.314-7.82Z"
}, null, -1), Ft = [
  Zt
];
function we(e, t) {
  return c(), u("svg", Vt, [...Ft]);
}
const Dt = { render: we }, Kt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dt,
  render: we
}, Symbol.toStringTag, { value: "Module" })), Rt = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}, Wt = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "M9.746.223a1.475 1.475 0 0 1 1.924.322l.009.011.09.127.008.012c.388.622.262 1.45-.322 1.924L4.833 8l6.634 5.39.114.106.01.01a1.475 1.475 0 0 1-1.995 2.164L1.553 9.135l-.113-.104-.01-.01a1.475 1.475 0 0 1 .134-2.165L9.607.32l.126-.09.013-.008Z"
}, null, -1), Gt = [
  Wt
];
function ye(e, t) {
  return c(), u("svg", Rt, [...Gt]);
}
const qt = { render: ye }, Ut = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qt,
  render: ye
}, Symbol.toStringTag, { value: "Module" })), Yt = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Qt = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "M14.243 4.245a1.075 1.075 0 0 1 1.512 1.511l-.07.077L11.519 10l4.167 4.167c.394.394.418 1.02.07 1.442l-.07.077a1.075 1.075 0 0 1-1.442.07l-.077-.07L10 11.519l-4.166 4.167a1.075 1.075 0 0 1-1.442.07l-.077-.07a1.075 1.075 0 0 1-.07-1.443l.07-.076L8.48 10 4.314 5.834a1.075 1.075 0 0 1-.07-1.443l.07-.076a1.075 1.075 0 0 1 1.443-.07l.076.07L10 8.48l4.168-4.167.076-.07Z"
}, null, -1), Jt = [
  Qt
];
function $e(e, t) {
  return c(), u("svg", Yt, [...Jt]);
}
const Xt = { render: $e }, en = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Xt,
  render: $e
}, Symbol.toStringTag, { value: "Module" })), tn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, nn = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M12.94 2.867a2.965 2.965 0 0 1 4.193 4.194l-5.378 5.373a4.87 4.87 0 0 1-3.466 1.437h-2.16v-2.16a4.87 4.87 0 0 1 1.437-3.468l5.373-5.376Zm-2.277 8.472 5.373-5.375.002.002a1.417 1.417 0 0 0-2.002-2.002L8.66 9.339a3.334 3.334 0 0 0-.984 2.372v.612h.612a3.334 3.334 0 0 0 2.374-.984Z",
  "clip-rule": "evenodd"
}, null, -1), on = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "M4.839 18h9.29a2.839 2.839 0 0 0 2.839-2.839v-3.354a.774.774 0 1 0-1.549 0v3.354a1.29 1.29 0 0 1-1.29 1.29h-9.29a1.29 1.29 0 0 1-1.29-1.29v-9.29c0-.713.577-1.29 1.29-1.29h3.354a.774.774 0 0 0 0-1.549H4.84A2.839 2.839 0 0 0 2 5.871v9.29A2.839 2.839 0 0 0 4.839 18Z"
}, null, -1), sn = [
  nn,
  on
];
function Se(e, t) {
  return c(), u("svg", tn, [...sn]);
}
const ln = { render: Se }, rn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ln,
  render: Se
}, Symbol.toStringTag, { value: "Module" })), an = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, cn = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1 12c0 6.062 4.938 11 11 11s11-4.938 11-11S18.062 1 12 1 1 5.938 1 12Zm1.956 0c0-4.987 4.057-9.044 9.044-9.044S21.044 7.013 21.044 12 16.987 21.044 12 21.044 2.956 16.987 2.956 12Z",
  "clip-rule": "evenodd"
}, null, -1), un = /* @__PURE__ */ _("circle", {
  cx: "12",
  cy: "17.648",
  r: "1.269",
  fill: "currentColor"
}, null, -1), dn = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "M12 14.884a.98.98 0 0 1-.978-.977V5.84A.98.98 0 0 1 12 4.862a.98.98 0 0 1 .978.978v8.067a.98.98 0 0 1-.978.977Z"
}, null, -1), hn = [
  cn,
  un,
  dn
];
function Oe(e, t) {
  return c(), u("svg", an, [...hn]);
}
const _n = { render: Oe }, fn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _n,
  render: Oe
}, Symbol.toStringTag, { value: "Module" })), pn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, vn = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.8 20.137c0 .518.351.863.877.863a.872.872 0 0 0 .878-.863v-5.782h10.968c.087 0 .263-.086.438-.172.439-.26.527-.777.264-1.208l-2.72-4.056 2.72-3.538c.087-.173.175-.345.175-.518 0-.518-.351-.863-.877-.863H6.677c-.526 0-.877.345-.877.863v15.274Zm11.055-7.508h-9.3V5.726h9.213l-2.106 2.761c-.176.26-.176.604 0 .95l2.193 3.192Z",
  "clip-rule": "evenodd"
}, null, -1), bn = [
  vn
];
function Ce(e, t) {
  return c(), u("svg", pn, [...bn]);
}
const gn = { render: Ce }, mn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gn,
  render: Ce
}, Symbol.toStringTag, { value: "Module" })), wn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, yn = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2 9.5c0 4.409 3.591 8 8 8s8-3.591 8-8-3.591-8-8-8-8 3.591-8 8Zm1.422 0A6.586 6.586 0 0 1 10 2.922 6.586 6.586 0 0 1 16.578 9.5 6.586 6.586 0 0 1 10 16.078 6.586 6.586 0 0 1 3.422 9.5Z",
  "clip-rule": "evenodd"
}, null, -1), $n = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "m9.803 12.812.054.002a.79.79 0 0 1 .75.748l.002.054v.363a.795.795 0 0 1-.806.804.793.793 0 0 1-.803-.75v-.417a.79.79 0 0 1 .75-.802l.054-.002Zm.269-8.312.095.001c1.8.04 3.13 1.239 3.175 2.888l.001.113c0 1.593-1.065 2.719-2.816 3.044l-.048.008-.086 1.198c-.025.312-.23.551-.526.576l-.05.002H9.79c-.304 0-.524-.221-.57-.522l-.006-.05-.147-1.734a.659.659 0 0 1 .157-.487.688.688 0 0 1 .49-.237c1.374-.086 2.157-.718 2.192-1.7l.001-.098c0-.964-.768-1.662-1.862-1.662-.79 0-1.474.326-2.1 1.007l-.074.083a.707.707 0 0 1-.547.266.654.654 0 0 1-.671-.659.73.73 0 0 1 .164-.458C7.69 5.04 8.697 4.53 9.953 4.5l.119-.001Z"
}, null, -1), Sn = [
  yn,
  $n
];
function Te(e, t) {
  return c(), u("svg", wn, [...Sn]);
}
const On = { render: Te }, Cn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: On,
  render: Te
}, Symbol.toStringTag, { value: "Module" })), Tn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "22",
  fill: "none",
  viewBox: "0 0 14 22"
}, kn = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "M13.918 9.07a.591.591 0 0 0-.501-.27h-5.25V.55a.556.556 0 0 0-.44-.533.598.598 0 0 0-.655.27L.07 12.386a.523.523 0 0 0 .01.543.59.59 0 0 0 .501.27h5.25v8.25c0 .252.181.47.44.532a.59.59 0 0 0 .657-.27l7-12.1a.523.523 0 0 0-.01-.543Z"
}, null, -1), xn = [
  kn
];
function ke(e, t) {
  return c(), u("svg", Tn, [...xn]);
}
const jn = { render: ke }, Mn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jn,
  render: ke
}, Symbol.toStringTag, { value: "Module" })), An = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "17",
  fill: "none",
  viewBox: "0 0 12 17"
}, En = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.633 12.367a.491.491 0 0 0 .354.14h2.328c.179 0 .318-.052.417-.154.1-.103.182-.25.247-.442.013-.14.029-.276.048-.41.02-.132.04-.269.059-.408.097-.458.287-.887.568-1.287.282-.4.605-.791.97-1.175.366-.384.724-.78 1.075-1.186.351-.407.648-.851.89-1.335a4.026 4.026 0 0 0 .405-1.633 3.732 3.732 0 0 0-.245-1.513 4.09 4.09 0 0 0-.95-1.456c-.442-.45-1.033-.813-1.775-1.09C8.282.138 7.367 0 6.28 0c-.995 0-1.876.14-2.644.42-.768.28-1.42.658-1.957 1.134a5.032 5.032 0 0 0-1.23 1.61A4.568 4.568 0 0 0 0 5.028a.58.58 0 0 0 .159.425.52.52 0 0 0 .384.161h2.04a.686.686 0 0 0 .447-.137c.112-.09.194-.23.245-.419.17-.814.497-1.407.983-1.778.486-.372 1.101-.558 1.847-.558a3.1 3.1 0 0 1 1.238.252c.39.169.7.413.929.733.229.32.32.712.272 1.175-.038.384-.19.758-.454 1.121a8.305 8.305 0 0 1-.963 1.087c-.377.361-.755.747-1.135 1.157-.38.41-.71.86-.988 1.35a4.113 4.113 0 0 0-.505 1.662c-.007.127-.01.253-.01.38v.38c0 .14.048.257.144.35Zm-.132 4.47a.56.56 0 0 0 .413.163h2.324a.585.585 0 0 0 .42-.163.546.546 0 0 0 .17-.412v-2.087a.57.57 0 0 0-.17-.42.571.571 0 0 0-.42-.17H4.914a.548.548 0 0 0-.413.17.582.582 0 0 0-.164.42v2.087c0 .166.055.303.164.412Z",
  "clip-rule": "evenodd"
}, null, -1), In = [
  En
];
function xe(e, t) {
  return c(), u("svg", An, [...In]);
}
const Ln = { render: xe }, Hn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ln,
  render: xe
}, Symbol.toStringTag, { value: "Module" })), Pn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}, Bn = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M17.417 3.704c0 .423-.373.765-.832.765H2.415c-.46 0-.832-.342-.832-.765 0-.422.373-.765.832-.765h2.577c.546.002 1.004-.378 1.058-.878C6.177.889 7.25-.003 8.531 0h1.937c1.28-.003 2.354.889 2.48 2.061.056.5.513.88 1.06.878h2.576c.221 0 .432.08.588.224a.735.735 0 0 1 .244.541Zm-1.1 3.083-.333 9.262c-.059 1.65-1.532 2.957-3.325 2.951H6.34c-1.792.006-3.264-1.3-3.325-2.948l-.333-9.265c-.015-.423.345-.777.804-.79.46-.014.844.317.86.74L4.677 16c.034.822.769 1.472 1.662 1.471h6.319c.895 0 1.63-.65 1.662-1.474l.333-9.262c.015-.422.4-.753.859-.74.459.014.819.368.804.79Zm-4.81-3.848H7.493c.11-.23.18-.473.213-.722.042-.39.4-.688.826-.688h1.937c.427 0 .784.297.826.688.032.25.103.493.212.722ZM8.331 14.53V8.017c0-.422-.373-.765-.832-.765-.459 0-.831.343-.831.765v6.518c0 .422.372.765.831.765.46 0 .832-.343.832-.765v-.004Zm4.002-6.514v6.518c0 .422-.372.765-.832.765-.459 0-.83-.343-.83-.765V8.016c0-.422.371-.765.83-.765.46 0 .832.343.832.765Z",
  "clip-rule": "evenodd"
}, null, -1), Nn = [
  Bn
];
function je(e, t) {
  return c(), u("svg", Pn, [...Nn]);
}
const zn = { render: je }, Vn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zn,
  render: je
}, Symbol.toStringTag, { value: "Module" })), Zn = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}, Fn = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "M7.147 10.333c-.522 0-.922-.372-.922-.858V7.331c.03-2.26 1.567-4.29 3.87-5.033 3.01-.972 6.297.515 7.342 3.317a.847.847 0 0 1-.553 1.086c-.492.143-1.014-.085-1.168-.514-.337-.915-1.044-1.659-1.996-2.088a4.203 4.203 0 0 0-3.01-.171c-1.567.514-2.611 1.887-2.642 3.431v2.145c0 .429-.4.83-.921.83Z"
}, null, -1), Dn = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M7.945 22h8.14c2.703 0 4.945-2.059 4.915-4.633v-4.232c0-2.545-2.212-4.603-4.946-4.603H7.945C5.212 8.532 3 10.59 3 13.135v4.261C3 19.941 5.212 22 7.945 22Zm-3.102-8.865c0-1.6 1.382-2.888 3.102-2.888h8.11c1.72 0 3.102 1.287 3.102 2.888v4.232c0 1.602-1.383 2.889-3.103 2.889H7.945c-1.72 0-3.102-1.287-3.102-2.889v-4.232Z",
  "clip-rule": "evenodd"
}, null, -1), Kn = /* @__PURE__ */ _("path", {
  fill: "currentColor",
  d: "M12 17.225c-.522 0-.922-.372-.922-.858v-2.202c0-.486.4-.858.922-.858s.921.372.921.858v2.202c0 .486-.399.858-.921.858Z"
}, null, -1), Rn = [
  Fn,
  Dn,
  Kn
];
function Me(e, t) {
  return c(), u("svg", Zn, [...Rn]);
}
const Wn = { render: Me }, Gn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Wn,
  render: Me
}, Symbol.toStringTag, { value: "Module" })), ce = "abc-icon", qn = /* @__PURE__ */ x({
  __name: "AbcIcon",
  props: {
    color: { default: "current" },
    name: {}
  },
  setup(e) {
    const t = e, s = Object.fromEntries(
      Object.entries(/* @__PURE__ */ Object.assign({ "/src/lib/icons/check-mark.svg": Kt, "/src/lib/icons/chevron-left.svg": Ut, "/src/lib/icons/cross.svg": en, "/src/lib/icons/edit.svg": rn, "/src/lib/icons/exclamation.svg": fn, "/src/lib/icons/flag.svg": mn, "/src/lib/icons/help.svg": Cn, "/src/lib/icons/lightning.svg": Mn, "/src/lib/icons/question-mark.svg": Hn, "/src/lib/icons/trash.svg": Vn, "/src/lib/icons/unlock.svg": Gn })).map(([l, i]) => [
        l.replace("/src/lib/icons/", "").replace(".svg", ""),
        i
      ])
    ), r = g(() => s[t.name]), o = g(() => [ce, `${ce}--${t.color}`]);
    return (l, i) => (c(), V(X(r.value), {
      class: b(o.value),
      role: "presentation",
      focusable: "false"
    }, null, 8, ["class"]));
  }
}), Q = /* @__PURE__ */ O(qn, [["__scopeId", "data-v-0c1e0ff2"]]);
function Un(e) {
  return Ge() ? (qe(e), !0) : !1;
}
function J(e) {
  return typeof e == "function" ? e() : Ue(e);
}
const Yn = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
function Qn(e, t) {
  var n;
  if (typeof e == "number")
    return e + t;
  const s = ((n = e.match(/^-?[0-9]+\.?[0-9]*/)) == null ? void 0 : n[0]) || "", r = e.slice(s.length), o = Number.parseFloat(s) + t;
  return Number.isNaN(o) ? e : o + r;
}
const Ae = Yn ? window : void 0;
function Jn() {
  const e = me(!1), t = ge();
  return t && Qe(() => {
    e.value = !0;
  }, t), e;
}
function Xn(e) {
  const t = Jn();
  return g(() => (t.value, !!e()));
}
function B(e, t = {}) {
  const { window: n = Ae } = t, s = Xn(() => n && "matchMedia" in n && typeof n.matchMedia == "function");
  let r;
  const o = me(!1), l = (f) => {
    o.value = f.matches;
  }, i = () => {
    r && ("removeEventListener" in r ? r.removeEventListener("change", l) : r.removeListener(l));
  }, d = Ye(() => {
    s.value && (i(), r = n.matchMedia(J(e)), "addEventListener" in r ? r.addEventListener("change", l) : r.addListener(l), o.value = r.matches);
  });
  return Un(() => {
    d(), i(), r = void 0;
  }), o;
}
function Ee(e, t = {}) {
  function n(a, p) {
    let v = J(e[J(a)]);
    return p != null && (v = Qn(v, p)), typeof v == "number" && (v = `${v}px`), v;
  }
  const { window: s = Ae, strategy: r = "min-width" } = t;
  function o(a) {
    return s ? s.matchMedia(a).matches : !1;
  }
  const l = (a) => B(() => `(min-width: ${n(a)})`, t), i = (a) => B(() => `(max-width: ${n(a)})`, t), d = Object.keys(e).reduce((a, p) => (Object.defineProperty(a, p, {
    get: () => r === "min-width" ? l(p) : i(p),
    enumerable: !0,
    configurable: !0
  }), a), {});
  function f() {
    const a = Object.keys(e).map((p) => [p, l(p)]);
    return g(() => a.filter(([, p]) => p.value).map(([p]) => p));
  }
  return Object.assign(d, {
    greaterOrEqual: l,
    smallerOrEqual: i,
    greater(a) {
      return B(() => `(min-width: ${n(a, 0.1)})`, t);
    },
    smaller(a) {
      return B(() => `(max-width: ${n(a, -0.1)})`, t);
    },
    between(a, p) {
      return B(() => `(min-width: ${n(a)}) and (max-width: ${n(p, -0.1)})`, t);
    },
    isGreater(a) {
      return o(`(min-width: ${n(a, 0.1)})`);
    },
    isGreaterOrEqual(a) {
      return o(`(min-width: ${n(a)})`);
    },
    isSmaller(a) {
      return o(`(max-width: ${n(a, -0.1)})`);
    },
    isSmallerOrEqual(a) {
      return o(`(max-width: ${n(a)})`);
    },
    isInBetween(a, p) {
      return o(`(min-width: ${n(a)}) and (max-width: ${n(p, -0.1)})`);
    },
    current: f,
    active() {
      const a = f();
      return g(() => a.value.length === 0 ? "" : a.value.at(-1));
    }
  });
}
const Gs = [
  "check-mark",
  "chevron-left",
  "cross",
  "edit",
  "exclamation",
  "flag",
  "help",
  "lightning",
  "question-mark",
  "trash",
  "unlock"
], Ie = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1280
};
var eo = typeof global == "object" && global && global.Object === Object && global, to = typeof self == "object" && self && self.Object === Object && self, ee = eo || to || Function("return this")(), D = ee.Symbol, Le = Object.prototype, no = Le.hasOwnProperty, oo = Le.toString, N = D ? D.toStringTag : void 0;
function so(e) {
  var t = no.call(e, N), n = e[N];
  try {
    e[N] = void 0;
    var s = !0;
  } catch {
  }
  var r = oo.call(e);
  return s && (t ? e[N] = n : delete e[N]), r;
}
var lo = Object.prototype, ro = lo.toString;
function ao(e) {
  return ro.call(e);
}
var io = "[object Null]", co = "[object Undefined]", ue = D ? D.toStringTag : void 0;
function uo(e) {
  return e == null ? e === void 0 ? co : io : ue && ue in Object(e) ? so(e) : ao(e);
}
function ho(e) {
  return e != null && typeof e == "object";
}
function He(e, t) {
  for (var n = -1, s = e == null ? 0 : e.length, r = Array(s); ++n < s; )
    r[n] = t(e[n], n, e);
  return r;
}
function Pe(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
function Be(e) {
  return e;
}
var _o = "[object AsyncFunction]", fo = "[object Function]", po = "[object GeneratorFunction]", vo = "[object Proxy]";
function Ne(e) {
  if (!Pe(e))
    return !1;
  var t = uo(e);
  return t == fo || t == po || t == _o || t == vo;
}
var U = ee["__core-js_shared__"], de = function() {
  var e = /[^.]+$/.exec(U && U.keys && U.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function bo(e) {
  return !!de && de in e;
}
var go = Function.prototype, mo = go.toString;
function wo(e) {
  if (e != null) {
    try {
      return mo.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var yo = /[\\^$.*+?()[\]{}|]/g, $o = /^\[object .+?Constructor\]$/, So = Function.prototype, Oo = Object.prototype, Co = So.toString, To = Oo.hasOwnProperty, ko = RegExp(
  "^" + Co.call(To).replace(yo, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function xo(e) {
  if (!Pe(e) || bo(e))
    return !1;
  var t = Ne(e) ? ko : $o;
  return t.test(wo(e));
}
function jo(e, t) {
  return e == null ? void 0 : e[t];
}
function te(e, t) {
  var n = jo(e, t);
  return xo(n) ? n : void 0;
}
function Mo(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var Ao = 800, Eo = 16, Io = Date.now;
function Lo(e) {
  var t = 0, n = 0;
  return function() {
    var s = Io(), r = Eo - (s - n);
    if (n = s, r > 0) {
      if (++t >= Ao)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
function Ho(e) {
  return function() {
    return e;
  };
}
var he = function() {
  try {
    var e = te(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Po = he ? function(e, t) {
  return he(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Ho(t),
    writable: !0
  });
} : Be;
const Bo = Po;
var No = Lo(Bo);
function zo(e, t, n, s) {
  for (var r = e.length, o = n + (s ? 1 : -1); s ? o-- : ++o < r; )
    if (t(e[o], o, e))
      return o;
  return -1;
}
function Vo(e) {
  return e !== e;
}
function Zo(e, t, n) {
  for (var s = n - 1, r = e.length; ++s < r; )
    if (e[s] === t)
      return s;
  return -1;
}
function Fo(e, t, n) {
  return t === t ? Zo(e, t, n) : zo(e, Vo, n);
}
function Do(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && Fo(e, t, 0) > -1;
}
function Ko(e, t) {
  return e === t || e !== e && t !== t;
}
var _e = Math.max;
function Ro(e, t, n) {
  return t = _e(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var s = arguments, r = -1, o = _e(s.length - t, 0), l = Array(o); ++r < o; )
      l[r] = s[t + r];
    r = -1;
    for (var i = Array(t + 1); ++r < t; )
      i[r] = s[r];
    return i[t] = n(l), Mo(e, this, i);
  };
}
function Wo(e, t) {
  return No(Ro(e, t, Be), e + "");
}
var Go = 9007199254740991;
function qo(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Go;
}
function Uo(e) {
  return e != null && qo(e.length) && !Ne(e);
}
function Yo(e) {
  return function(t) {
    return e(t);
  };
}
var z = te(Object, "create");
function Qo() {
  this.__data__ = z ? z(null) : {}, this.size = 0;
}
function Jo(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Xo = "__lodash_hash_undefined__", es = Object.prototype, ts = es.hasOwnProperty;
function ns(e) {
  var t = this.__data__;
  if (z) {
    var n = t[e];
    return n === Xo ? void 0 : n;
  }
  return ts.call(t, e) ? t[e] : void 0;
}
var os = Object.prototype, ss = os.hasOwnProperty;
function ls(e) {
  var t = this.__data__;
  return z ? t[e] !== void 0 : ss.call(t, e);
}
var rs = "__lodash_hash_undefined__";
function as(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = z && t === void 0 ? rs : t, this;
}
function I(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var s = e[t];
    this.set(s[0], s[1]);
  }
}
I.prototype.clear = Qo;
I.prototype.delete = Jo;
I.prototype.get = ns;
I.prototype.has = ls;
I.prototype.set = as;
function is() {
  this.__data__ = [], this.size = 0;
}
function R(e, t) {
  for (var n = e.length; n--; )
    if (Ko(e[n][0], t))
      return n;
  return -1;
}
var cs = Array.prototype, us = cs.splice;
function ds(e) {
  var t = this.__data__, n = R(t, e);
  if (n < 0)
    return !1;
  var s = t.length - 1;
  return n == s ? t.pop() : us.call(t, n, 1), --this.size, !0;
}
function hs(e) {
  var t = this.__data__, n = R(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function _s(e) {
  return R(this.__data__, e) > -1;
}
function fs(e, t) {
  var n = this.__data__, s = R(n, e);
  return s < 0 ? (++this.size, n.push([e, t])) : n[s][1] = t, this;
}
function H(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var s = e[t];
    this.set(s[0], s[1]);
  }
}
H.prototype.clear = is;
H.prototype.delete = ds;
H.prototype.get = hs;
H.prototype.has = _s;
H.prototype.set = fs;
var ps = te(ee, "Map");
function vs() {
  this.size = 0, this.__data__ = {
    hash: new I(),
    map: new (ps || H)(),
    string: new I()
  };
}
function bs(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function W(e, t) {
  var n = e.__data__;
  return bs(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function gs(e) {
  var t = W(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function ms(e) {
  return W(this, e).get(e);
}
function ws(e) {
  return W(this, e).has(e);
}
function ys(e, t) {
  var n = W(this, e), s = n.size;
  return n.set(e, t), this.size += n.size == s ? 0 : 1, this;
}
function P(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var s = e[t];
    this.set(s[0], s[1]);
  }
}
P.prototype.clear = vs;
P.prototype.delete = gs;
P.prototype.get = ms;
P.prototype.has = ws;
P.prototype.set = ys;
var $s = "__lodash_hash_undefined__";
function Ss(e) {
  return this.__data__.set(e, $s), this;
}
function Os(e) {
  return this.__data__.has(e);
}
function K(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new P(); ++t < n; )
    this.add(e[t]);
}
K.prototype.add = K.prototype.push = Ss;
K.prototype.has = Os;
function fe(e, t) {
  return e.has(t);
}
function Cs(e) {
  return ho(e) && Uo(e);
}
function Ts(e, t, n) {
  for (var s = -1, r = e == null ? 0 : e.length; ++s < r; )
    if (n(t, e[s]))
      return !0;
  return !1;
}
function ks(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var xs = Math.min;
function js(e, t, n) {
  for (var s = n ? Ts : Do, r = e[0].length, o = e.length, l = o, i = Array(o), d = 1 / 0, f = []; l--; ) {
    var a = e[l];
    l && t && (a = He(a, Yo(t))), d = xs(a.length, d), i[l] = !n && (t || r >= 120 && a.length >= 120) ? new K(l && a) : void 0;
  }
  a = e[0];
  var p = -1, v = i[0];
  e:
    for (; ++p < r && f.length < d; ) {
      var h = a[p], y = t ? t(h) : h;
      if (h = n || h !== 0 ? h : 0, !(v ? fe(v, y) : s(f, y, n))) {
        for (l = o; --l; ) {
          var m = i[l];
          if (!(m ? fe(m, y) : s(e[l], y, n)))
            continue e;
        }
        v && v.push(y), f.push(h);
      }
    }
  return f;
}
function Ms(e) {
  return Cs(e) ? e : [];
}
var As = Wo(function(e) {
  var t = He(e, Ms);
  return t.length && t[0] === e[0] ? js(t) : [];
});
const Es = As, Is = { class: "abc-table" }, Ls = { key: 0 }, Hs = { class: "abc-table__row" }, Ps = ["colspan"], Bs = { class: "abc-table__body" }, Ns = {
  key: 1,
  class: "abc-table__cell abc-table__body-cell abc-table__body-cell--delimiter"
}, zs = /* @__PURE__ */ x({
  __name: "AbcTable",
  props: {
    columns: {},
    rows: {},
    columnWidths: { default: () => [] },
    tabular: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, n = Ee(Ie), s = g(
      () => t.columns !== void 0 && t.columns.length > 0
    ), r = g(
      () => (
        // If all the values of props.columnWidths isn't mapped correctly to the same indicies, we could be causing misalignment of columns,
        // hence Array.map() is used to ensure that we always map the elements 1-1.
        t.columnWidths.map((o) => {
          if (o === void 0)
            return;
          if (typeof o == "string")
            return o;
          const l = Object.keys(o), i = Es(
            l,
            n.current().value
          ), d = ks(i);
          if (d)
            return o[d];
        })
      )
    );
    return (o, l) => (c(), u("table", Is, [
      s.value ? (c(), u("thead", Ls, [
        _("tr", Hs, [
          (c(!0), u(M, null, E(o.columns, (i, d) => (c(), u("th", {
            key: d,
            class: "abc-table__cell abc-table__header-cell",
            scope: "col",
            colspan: i.span || 1,
            style: oe({ width: r.value[d] })
          }, [
            w(o.$slots, "head-cell", Z(F({
              cell: i.value,
              isFirst: d === 0,
              isLast: d === o.columns.length - 1
            })), () => [
              k(S(i.value), 1)
            ], !0)
          ], 12, Ps))), 128))
        ])
      ])) : A("", !0),
      _("tbody", Bs, [
        (c(!0), u(M, null, E(o.rows, (i, d) => {
          var f, a;
          return c(), u("tr", {
            key: d,
            class: b(["abc-table__row", {
              "abc-table__row--last-before-delimiter": (f = o.rows[d + 1]) == null ? void 0 : f.isDelimiter,
              "abc-table__row--first-after-delimiter": (a = o.rows[d - 1]) == null ? void 0 : a.isDelimiter
            }])
          }, [
            i.isDelimiter ? (c(), u(M, { key: 0 }, [
              s.value ? (c(!0), u(M, { key: 0 }, E(o.columns, (p, v) => (c(), u("th", {
                key: v,
                class: "abc-table__cell abc-table__body-cell abc-table__body-cell--delimiter"
              }))), 128)) : (c(), u("th", Ns))
            ], 64)) : i.cells ? (c(!0), u(M, { key: 1 }, E(i.cells, (p, v) => (c(), V(X(v === 0 && o.tabular ? "th" : "td"), {
              key: v,
              class: "abc-table__cell abc-table__body-cell",
              style: oe({ width: s.value ? void 0 : r.value[v] })
            }, {
              default: T(() => [
                w(o.$slots, "body-cell", Z(F({
                  cell: p,
                  row: i,
                  isFirstRow: d === 0,
                  isLastRow: d === o.rows.length - 1,
                  isFirst: v === 0,
                  isLast: v === i.cells.length - 1
                })), () => [
                  k(S(p), 1)
                ], !0)
              ]),
              _: 2
            }, 1032, ["style"]))), 128)) : A("", !0)
          ], 2);
        }), 128))
      ])
    ]));
  }
}), ze = /* @__PURE__ */ O(zs, [["__scopeId", "data-v-7502db59"]]), Vs = { class: "abc-responsive-table" }, Zs = /* @__PURE__ */ x({
  __name: "AbcResponsiveTable",
  props: {
    desktopBreakpoint: { default: "md" },
    columns: {},
    rows: {},
    columnWidths: { default: () => [] },
    tabular: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, n = Ee(Ie), s = g(() => n.smaller(t.desktopBreakpoint).value), r = g(() => {
      var l, i;
      return t.columns !== void 0 ? t.columns.length : ((i = (l = t.rows) == null ? void 0 : l[0]) == null ? void 0 : i.cells) !== void 0 ? t.rows[0].cells.length : 0;
    }), o = g(() => {
      if (!s.value)
        return [
          {
            columns: t.columns,
            rows: t.rows
          }
        ];
      const l = [], d = 2 - 1;
      for (let f = d; f < r.value; f++) {
        const a = t.columns && t.columns.length > 0 ? [t.columns[0], ...t.columns.slice(f, f + d)] : void 0, p = t.rows.map((v) => v.cells ? {
          ...v,
          cells: [v.cells[0], ...v.cells.slice(f, f + d)]
        } : v);
        l.push({
          columns: a,
          rows: p
        });
      }
      return l;
    });
    return (l, i) => (c(), u("div", Vs, [
      (c(!0), u(M, null, E(o.value, (d, f) => (c(), V(ze, {
        key: f,
        columns: d.columns,
        rows: d.rows,
        "column-widths": l.columnWidths,
        tabular: l.tabular
      }, {
        "head-cell": T((a) => [
          w(l.$slots, "head-cell", Z(F({
            ...a,
            isFirstTable: f === 0,
            isLastTable: f === o.value.length - 1
          })), () => [
            k(S(a.cell), 1)
          ], !0)
        ]),
        "body-cell": T((a) => [
          w(l.$slots, "body-cell", Z(F({
            ...a,
            isFirstTable: f === 0,
            isLastTable: f === o.value.length - 1
          })), () => [
            k(S(a.cell), 1)
          ], !0)
        ]),
        _: 2
      }, 1032, ["columns", "rows", "column-widths", "tabular"]))), 128))
    ]));
  }
}), Fs = /* @__PURE__ */ O(Zs, [["__scopeId", "data-v-126f7206"]]), Ds = ["aria-checked"], C = "abc-toggle", Ks = /* @__PURE__ */ x({
  __name: "AbcToggle",
  props: {
    modelValue: { type: Boolean, required: !0 },
    modelModifiers: {}
  },
  emits: ["update:modelValue"],
  setup(e) {
    const t = Je(e, "modelValue"), n = g(() => ({
      [C]: !0,
      [`${C}--checked`]: t.value
    }));
    return (s, r) => (c(), u("button", {
      type: "button",
      role: "switch",
      class: b(n.value),
      "aria-checked": t.value,
      onClick: r[0] || (r[0] = (o) => t.value = !t.value)
    }, [
      Y(Q, {
        name: "check-mark",
        class: b([
          `${C}__icon`,
          `${C}__icon-check`,
          t.value ? `${C}__icon--visible` : ""
        ])
      }, null, 8, ["class"]),
      _("span", {
        class: b(`${C}__knob`)
      }, null, 2),
      Y(Q, {
        name: "cross",
        class: b([
          `${C}__icon`,
          `${C}__icon-cross`,
          t.value ? "" : `${C}__icon--visible`
        ])
      }, null, 8, ["class"])
    ], 10, Ds));
  }
}), Rs = /* @__PURE__ */ O(Ks, [["__scopeId", "data-v-fe086a85"]]), pe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbcAccordion: at,
  AbcBadge: ct,
  AbcDropdown: Ht,
  AbcFloatingContainer: Bt,
  AbcHeading: zt,
  AbcIcon: Q,
  AbcResponsiveTable: Fs,
  AbcTable: ze,
  AbcToggle: Rs
}, Symbol.toStringTag, { value: "Module" })), qs = {
  install: (e) => {
    for (const t in pe)
      e.component(t, pe[t]);
  }
};
export {
  at as AbcAccordion,
  ct as AbcBadge,
  Ht as AbcDropdown,
  Bt as AbcFloatingContainer,
  zt as AbcHeading,
  Q as AbcIcon,
  Gs as AbcIcons,
  Fs as AbcResponsiveTable,
  ze as AbcTable,
  Rs as AbcToggle,
  Ie as breakpoints,
  qs as default
};
